import React from 'react';

import { StyleSheet, View } from 'react-native';

import Currency from 'components/currency';
import { Typography } from 'components/ui';
import { useIsLargeFontScale } from 'hooks/use-is-large-font-scale';
import { t } from 'state/intl/translations';
import { BODY_MAX_FONT_SIZE_MULTIPLIER } from 'styles/constants/fonts';

interface PrepaidBalanceInfoProps {
  prepaidBalance: number;
  orderTotal: number;
}

export const PrepaidBalanceInfo: React.FC<PrepaidBalanceInfoProps> = ({
  prepaidBalance,
  orderTotal,
}) => {
  const amountLeft = Math.max(orderTotal - prepaidBalance, 0);
  const isLargeFontScale = useIsLargeFontScale();

  return (
    <>
      <BalanceRow
        label={t('prepaidCardBalance', { cardAlias: t('cardAlias.bk') })}
        amount={prepaidBalance}
        isStacked={isLargeFontScale}
      />
      <BalanceRow
        label={t('amountLeft', 'Amount Left')}
        amount={amountLeft}
        isStacked={isLargeFontScale}
      />
      <BalanceRow
        label={t('orderTotal', 'Order Total')}
        amount={orderTotal}
        isStacked={isLargeFontScale}
      />
    </>
  );
};

function BalanceRow({
  label,
  amount,
  isStacked,
}: {
  label: string;
  amount: number;
  isStacked: boolean;
}) {
  return (
    <View testID="prepaid-balance-info-row" style={[styles.row, isStacked && styles.stackedRow]}>
      <Typography fontSize="sm" maxFontSizeMultiplier={BODY_MAX_FONT_SIZE_MULTIPLIER}>
        {label}
      </Typography>
      <Currency
        amount={amount}
        textProps={{
          style: styles.currency,
          fontSize: 'sm',
          maxFontSizeMultiplier: BODY_MAX_FONT_SIZE_MULTIPLIER,
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  currency: {
    margin: 0,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 2,
    marginBottom: 2,
  },
  stackedRow: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 2,
  },
});
